"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var Icon_1 = require("../Icon");
require("./Bar.scss");
var BarNavDropDown = /** @class */ (function (_super) {
    __extends(BarNavDropDown, _super);
    function BarNavDropDown() {
        var _this = _super.call(this) || this;
        _this.state = {
            menuDisplay: Display.none
        };
        _this.handleMouseOver = _this.handleMouseOver.bind(_this);
        _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
        return _this;
    }
    BarNavDropDown.prototype.handleMouseOver = function (event) {
        this.setState({ menuDisplay: Display.block });
    };
    BarNavDropDown.prototype.handleMouseLeave = function (event) {
        this.setState({ menuDisplay: Display.none });
    };
    BarNavDropDown.prototype.render = function () {
        var menuStyles = {
            display: Display[this.state.menuDisplay], minWidth: '100%'
        };
        var dropdownClasses = classNames({
            'dropdown': true,
            'dropdown-expanded': this.state.menuDisplay === Display.block
        });
        var anchorClasses = classNames({
            'dropdown-toggle': true,
            'navbar-link': true,
            'active': this.state.menuDisplay === Display.block
        });
        var icon = this.props.icon ? React.createElement(Icon_1.Icon, { icon: this.props.icon }) : null;
        return (React.createElement("li", { className: dropdownClasses, onMouseOver: this.handleMouseOver, onMouseLeave: this.handleMouseLeave },
            React.createElement("a", { href: "#", className: anchorClasses, "data-toggle": "dropdown", role: "button", "aria-haspopup": "true", "aria-expanded": "false" },
                icon,
                "\u00A0\u00A0",
                this.props.text,
                " ",
                React.createElement("span", { className: "caret" })),
            React.createElement("ul", { className: "dropdown-menu", style: menuStyles }, this.props.children)));
    };
    return BarNavDropDown;
}(React.Component));
exports.BarNavDropDown = BarNavDropDown;
var Display;
(function (Display) {
    Display[Display["none"] = 0] = "none";
    Display[Display["block"] = 1] = "block";
})(Display || (Display = {}));
//# sourceMappingURL=BarNavDropDown.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@abb/common-ux/dist/components/Bar/BarNavDropDown.js
// module id = 573
// module chunks = 1